export { default as SpecialWrapper } from './SpecialWrapper';
export { default as SnowflakesAnimation } from './SnowflakesAnimation';
export { default as FireworksAnimation } from './FireworksAnimation';
export { default as EasterAnimation } from './EasterAnimation';
export { default as BackgroundSpecial } from './BackgroundSpecial';

const SPECIAL_EFFECTS_KEY = 'abs_special_effects_enabled';

/**
 * Check if special effects are enabled (stored in localStorage)
 * Default is true (enabled)
 * @returns {boolean}
 */
export function isSpecialEffectsEnabled() {
  const stored = localStorage.getItem(SPECIAL_EFFECTS_KEY);
  // Default to true if not set
  if (stored === null) {
    return true;
  }
  return stored === 'true';
}

/**
 * Set special effects enabled/disabled preference
 * @param {boolean} enabled
 */
export function setSpecialEffectsEnabled(enabled) {
  localStorage.setItem(SPECIAL_EFFECTS_KEY, enabled ? 'true' : 'false');
}

/**
 * Check if it's Christmas season (December 15-26)
 */
export function isChristmasSeason() {
  const now = new Date();
  const month = now.getMonth(); // 0-indexed, so December is 11
  const day = now.getDate();

  // December 15-26
  return month === 11 && day >= 15 && day <= 26;
}

/**
 * Check if it's New Year season (December 27 - January 3)
 */
export function isNewYearSeason() {
  const now = new Date();
  const month = now.getMonth(); // 0-indexed
  const day = now.getDate();

  // December 27-31 or January 1-3
  return (month === 11 && day >= 27) || (month === 0 && day <= 3);
}

/**
 * Calculate Easter Sunday for a given year using the Meeus/Jones/Butcher algorithm.
 * Returns a Date object set to Easter Sunday midnight (local time).
 */
function getEasterDate(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = March, 4 = April
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

/**
 * Check if it's Easter season (7 days ending on Easter Monday, i.e. -6 to +1 days from Easter Sunday)
 */
export function isEasterSeason() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const easter = getEasterDate(now.getFullYear());

  const seasonStart = new Date(easter);
  seasonStart.setDate(easter.getDate() - 6); // 6 days before Easter Sunday

  const seasonEnd = new Date(easter);
  seasonEnd.setDate(easter.getDate() + 2); // Easter Monday

  return today >= seasonStart && today <= seasonEnd;
}

/**
 * Check if any special season is active
 */
export function isSpecialSeason() {
  return isChristmasSeason() || isNewYearSeason() || isEasterSeason();
}

